import { APP_BASE_HREF, PlatformLocation, registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import localeRu from '@angular/common/locales/ru';
import { APP_ID, LOCALE_ID, NgModule } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { environment, IS_SMARTEDIT } from '@core/const';
import { isSmartedit } from '@core/utils';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { DeviceService } from '@shared/services';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { SmartEditConfig } from '@spartacus/smartedit';
import { BreakpointService } from '@spartacus/storefront';
import { provideEnvironmentNgxMask } from 'ngx-mask';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './routing';
import { SpartacusModule } from './spartacus/spartacus.module';

registerLocaleData(localeRu, 'ru');

@NgModule({
  declarations: [AppComponent],
  imports: [
    StoreModule.forRoot({}),
    EffectsModule.forRoot([]),
    StoreDevtoolsModule.instrument({ logOnly: environment.production, connectInZone: true }),
    AppRoutingModule,
    SpartacusModule,
    RouterOutlet,
  ],
  providers: [
    { provide: APP_ID, useValue: 'sdvor-app' },
    { provide: LOCALE_ID, useValue: 'ru-RU' },
    {
      provide: IS_SMARTEDIT,
      useFactory: (platformLocation: PlatformLocation, config: SmartEditConfig): boolean => {
        const path = platformLocation.pathname;
        const params = platformLocation.search?.slice(platformLocation.search[0] === '?' ? 1 : 0);

        return isSmartedit(path, params, config);
      },
      deps: [PlatformLocation, SmartEditConfig],
    },
    {
      provide: APP_BASE_HREF,
      useFactory: (isSmarteditEnv: boolean): string => {
        return isSmarteditEnv ? environment.smarteditBaseHref : environment.appBaseHref;
      },
      deps: [IS_SMARTEDIT],
    },
    {
      // Обязательно нужно провайдить в app.module. По непонятным причинам данный сервис на SSR в спартакус не
      // перезаписывается, если его провайдить там же, где объявлен
      provide: BreakpointService,
      useExisting: DeviceService,
    },
    provideEnvironmentNgxMask(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideClientHydration(),
  ],
})
export class AppModule {}
